export const SITE = {
  name: "NANOMAX HOLO SOLUTIONS",
  legal: "NANOMAX HOLO SOLUTIONS LLC",
  domain: "https://nanomax.ae",
  phone: "+971 58 5378822",
  phoneRaw: "+971585378822",
  whatsapp: "https://wa.me/971585378822",
  email: "sales@nanomaxholosolutions.com",
  address: "Sharjah Media City, Sharjah, United Arab Emirates",
  city: "Sharjah",
  tagline: "Advanced Hologram & Security Label Solutions in the UAE",
};

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/a626e27d-2825-417f-8e71-42293c86cb0d/images/38b253dfd0c1fab0c811eff6dc5682544bb3e13c3efb81cd20325664a5b43daf.jpeg",
  qr: "https://static.prod-images.emergentagent.com/jobs/a626e27d-2825-417f-8e71-42293c86cb0d/images/1a857bc88c37fbfb6598b522b9405b3d09fa417d4bb986e03b73eb2bdfecaa7f.jpeg",
  tamper: "https://static.prod-images.emergentagent.com/jobs/a626e27d-2825-417f-8e71-42293c86cb0d/images/02d3bcda26e6e612273f40e4e3e60295e22219a47048ef17deaadcd060297d9a.jpeg",
  serial: "https://static.prod-images.emergentagent.com/jobs/a626e27d-2825-417f-8e71-42293c86cb0d/images/8139dc7f027c91457627751f9966e8eb4e17be0ce158c6ed1da9272adcfbd986.jpeg",
  holo3d: "https://static.prod-images.emergentagent.com/jobs/a626e27d-2825-417f-8e71-42293c86cb0d/images/817daf1a628a62fbdc2086fb3ae65b52f6de53987b0fe92feb05c6263720c9a7.jpeg",
  ctaBg: "https://static.prod-images.emergentagent.com/jobs/a626e27d-2825-417f-8e71-42293c86cb0d/images/6cc1aee3c9482f08531fc2cb655f963b55a5f29e0c1c006b4cc15fd66da2c60e.jpeg",
  foil: "https://images.pexels.com/photos/38395117/pexels-photo-38395117.jpeg",
  dubai: "https://images.unsplash.com/photo-1772090131833-f7db87feab28?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  machine: "https://images.pexels.com/photos/19316522/pexels-photo-19316522.png",
  techLines: "https://images.unsplash.com/photo-1714548529197-537c1f0b6aa7?q=85&w=1600",
};
